import React, { Component } from "react";
import ValidationText from "../../../utils/validation/ValidationText";
import ButtonLoader from "../../common/buttonLoader/ButtonLoader";
import TextInput from "../../UIComponent/TextInput";

function ResetPassword(props) {
    return (
        <div className="w-full">
          <div className="2xl:py-5 2xl:pt-5 lg:py-5 lg:pt-5">
            <div className="grid grid-cols-12 gap-6 w-full">
              <div className="col-span-12">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <div className="grid grid-cols-12 gap-6">
                      <div className="xl:col-span-6 lg:col-span-6 col-span-12">
                        <h2 className="text-xl text-[#757575] font-bold mb-1">
                         New Password <span className="text-[#c00000]">*</span>
                        </h2>
                        <TextInput
                         type="password"
                         name="password"
                         value={props.resetPasswordDetails.password}
                         onBlur={() => props.validateField("password")}
                         handleChange={props.handleChange}
                         />
                        <ValidationText error={props.validState?.error?.password} />
                      </div>
                      <div className="xl:col-span-6 lg:col-span-6 col-span-12">
                        <h2 className="text-xl text-[#757575] font-bold mb-1">
                          Confirm Password <span className="text-[#c00000]">*</span>
                        </h2>
                        <TextInput
                         type="password"
                         name="confirmPassword"
                         value={props.resetPasswordDetails.confirmPassword}
                         onBlur={() => props.validateField("confirmPassword")}
                         handleChange={props.handleChange}
                         />
                        <ValidationText error={props.validState?.error?.confirmPassword} />
                      </div>
                    </div>
                    <p className="text-sm text-gray-500 mt-5">
                    Password must be at least 6 alphanumeric characters and contain at least one uppercase and one special character (@#$%)
                    </p>
                  </div>
      
                  <div className="col-span-12 flex justify-end mt-4">
                    {props.isLoading ? (
                      <ButtonLoader />
                    ) : (
                      <button
                        className="w-50 px-7 py-3 btn-sm btn-red text-white font-semibold"
                        onClick={() => props.resetPassword()}
                      >
                        Reset Password
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
}
export default ResetPassword;
